import { ProductCenterRouteMap } from '@/new-router/product-center'

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/
const Home = () => import('@/views/Home/home')
const dongleList = () => import('@/views/Dongle/dongleList')

export default [
  {
    path: '/dongle',
    name: 'dongle',
    component: Home,
    meta: {
      title: '加密狗管理',
      showSubiems: false,
      sort: 5,
      modules: 'dongle',
      permission: 'device:root ',
    },
    children: [
      {
        path: 'dongleList',
        name: 'dongleList',
        component: dongleList,
        meta: {
          title: '加密狗列表',
          active: ['dongleList'],
          permission: 'device:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.DongleManagement],
        },
      },
    ],
  },
]
